/**
 * Staff Tab Content Component
 *
 * Contains all charts, tables, and visualizations specific to the Staff tab.
 */

import React from 'react';
import { MetricsGrid } from '../MetricsGrid';
import type { MetricData } from '../../types/DashboardTypes';
import styles from './TabContent.module.scss';
import { TopServiceDurationTable } from '../Tables/Staff/TopServiceDurationTable';
import { HorizontalBarChart } from '../Charts/Common/HorizontalBarChart.tsx/HorizontalBarChart';
import { TotalAppointmentsPerStaffChart } from '../Charts/Staff/TotalAppointmentsPerStaffChart';
import { staffAppointmentsData, tipsDistributionData, serviceDurationData } from '../Charts/Staff/staffChartsMockData';

interface StaffTabContentProps {
    metrics: MetricData[];
}

export const StaffTabContent: React.FC<StaffTabContentProps> = ({ metrics }) => {
    return (
        <div className={styles.tabContent}>
            {/* Metrics Grid */}
            <MetricsGrid metrics={metrics} />
            {/* Staff Analytics */}
            <div className={styles.analyticsSection}>
                <div className={styles.tableContainer}>
                    <TotalAppointmentsPerStaffChart
                        title="Total appointments per staff"
                        data={staffAppointmentsData}
                    />
                </div>
            </div>

            {/* Charts Section - Staff-specific visualizations */}
            <div className={styles.chartsSection}>
                <div className={styles.tableContainer}>
                    <TopServiceDurationTable
                        title="Average service duration"
                        data={serviceDurationData}
                    />
                </div>

                <div className={styles.tableContainer}>
                    <HorizontalBarChart
                        data={tipsDistributionData}
                        title="Tips distribution"
                        isCurrency={true}
                    />
                </div>
            </div>
        </div>
    );
};
